export default "__VITE_ASSET__D$V3Hpef__"